import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { testidExtension } from './testid.extension';
import { FormlyWrapperTestid } from './testid.wrapper';

@NgModule({
  declarations: [FormlyWrapperTestid],
  exports: [FormlyWrapperTestid],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      wrappers: [{ name: 'field-testid', component: FormlyWrapperTestid }],
      extensions: [
        { name: 'field-testid', extension: { onPopulate: testidExtension } },
      ],
    }),
  ],
})
export class FormFieldsTestidModule {}
